// extracted by css-extract-rspack-plugin
export default {"watch-button":"p_jwUN","watchButton":"p_jwUN"};